const REVIEW_ANALYSIS_BRANDS = {
  airbnb: 'Airbnb',
  booking: 'Booking',
  bestbuy: 'Best Buy',
  expedia: 'Expedia',
  google_maps: 'Google Maps',
  glassdoor: 'Glassdoor',
  homedepot: 'Home Depot',
  hotels: 'Hotels',
  etsy: 'Etsy',
  indeed: 'Indeed',
  target: 'Target',
  tripadvisor: 'Tripadvisor',
  trustpilot: 'Trustpilot',
  walmart: 'Walmart',
  yelp: 'Y.E.L.P',
};

const getReviewAnalysisBrand = serviceId => {
  const match = serviceId?.match(/^(.+)_reviews_(?:sentiment|summary)$/);
  return match && Object.prototype.hasOwnProperty.call(REVIEW_ANALYSIS_BRANDS, match[1])
    ? REVIEW_ANALYSIS_BRANDS[match[1]]
    : undefined;
};

export const localizeServiceTitle = (t, serviceId, fallbackTitle = serviceId) => {
  const logicalServiceId = serviceId?.replace(/_v\d+$/, '');

  switch (logicalServiceId) {
  case '1688_search':
    return t('title.brandSearchScraper', { brand: '1688' });
  case 'allegro':
    return t('title.brandScraper', { brand: 'Allegro' });
  case 'angi':
    return t('title.brandScraper', { brand: 'Angi' });
  case 'apollo':
    return t('title.brandScraper', { brand: 'Apollo' });
  case 'asos_products':
    return t('title.brandProductsScraper', { brand: 'Asos' });
  case 'autozone_products':
    return t('title.brandProductsScraper', { brand: 'AutoZone' });
  case 'baidu_maps':
    return t('title.brandScraper', { brand: 'Baidu Maps' });
  case 'better_business_bureau':
    return t('title.brandScraper', { brand: 'BBB Business' });
  case 'better_business_bureau_reviews':
    return t('title.brandReviewsScraper', { brand: 'BBB Business' });
  case 'bing_places':
    return t('title.brandScraper', { brand: 'Bing Maps' });
  case 'booking_reviews_monitoring':
    return t('title.brandReviewsMonitoring', { brand: 'Booking' });
  case 'bradyindustries_products':
    return t('title.brandProductsScraper', { brand: 'Brady Industries' });
  case 'builtwith':
    return t('title.brandScraper', { brand: 'BuiltWith' });
  case 'cdw_products':
    return t('title.brandProductsScraper', { brand: 'CDW' });
  case 'craigslist':
    return t('title.brandScraper', { brand: 'Craigslist' });
  case 'crunchbase':
    return t('title.brandScraper', { brand: 'Crunchbase' });
  case 'crunchbase_search':
    return t('title.brandSearchScraper', { brand: 'Crunchbase' });
  case 'decathlon_products':
    return t('title.brandProductsScraper', { brand: 'Decathlon' });
  case 'deliveroo':
    return t('title.brandScraper', { brand: 'Deliveroo' });
  case 'deliveroo_reviews':
    return t('title.brandReviewsScraper', { brand: 'Deliveroo' });
  case 'domaininfo':
    return t('title.domainInformation');
  case 'eventbrite':
    return t('title.brandScraper', { brand: 'Eventbrite' });
  case 'feedbackcompany':
    return t('title.brandScraper', { brand: 'Feedback Company' });
  case 'feedbackcompany_reviews':
    return t('title.brandReviewsScraper', { brand: 'Feedback Company' });
  case 'feefo_reviews':
    return t('title.brandReviewsScraper', { brand: 'Feefo' });
  case 'ferguson_products':
    return t('title.brandProductsScraper', { brand: 'Ferguson' });
  case 'gemplers_products':
    return t('title.brandProductsScraper', { brand: 'Gemplers' });
  case 'glassdoor_company_jobs':
    return t('title.brandCompanyJobs', { brand: 'Glassdoor' });
  case 'glassdoor_company_search':
    return t('title.brandCompanySearch', { brand: 'Glassdoor' });
  case 'globalindustrial_products':
    return t('title.brandProductsScraper', { brand: 'GlobalIndustrial' });
  case 'google_maps_reviews_monitoring':
    return t('title.brandReviewsMonitoring', { brand: 'Google Maps' });
  case 'google_play_reviews_monitoring':
    return t('title.brandReviewsMonitoring', { brand: 'Google Play' });
  case 'google_search_autocomplete':
    return t('title.googleSearchAutocomplete');
  case 'grainger_products':
    return t('title.brandProductsScraper', { brand: 'Grainger' });
  case 'groupon_products':
    return t('title.brandProductsScraper', { brand: 'Groupon' });
  case 'homedepot_products':
    return t('title.brandProductsScraper', { brand: 'Home Depot' });
  case 'immowelt':
    return t('title.brandScraper', { brand: 'Immowelt' });
  case 'ipinfo':
    return t('title.brandScraper', { brand: 'IPInfo' });
  case 'kununu_reviews':
    return t('title.brandReviewsScraper', { brand: 'Kununu' });
  case 'meetup':
    return t('title.brandScraper', { brand: 'Meetup' });
  case 'menards_products':
    return t('title.brandProductsScraper', { brand: 'Menards' });
  case 'napaonline_products':
    return t('title.brandProductsScraper', { brand: 'NapaOnline' });
  case 'newegg_products':
    return t('title.brandProductsScraper', { brand: 'Newegg' });
  case 'northerntool_products':
    return t('title.brandProductsScraper', { brand: 'Northerntool' });
  case 'olx':
    return t('title.brandScraper', { brand: 'OLX' });
  case 'otto_products':
    return t('title.brandProductsScraper', { brand: 'Otto' });
  case 'pinterest':
    return t('title.brandBoardScraper', { brand: 'Pinterest' });
  case 'producthunt_profiles':
    return t('title.brandProfilesScraper', { brand: 'Product Hunt' });
  case 'shopify_apps':
    return t('title.brandAppsScraper', { brand: 'Shopify' });
  case 'streeteasy':
    return t('title.brandScraper', { brand: 'StreetEasy' });
  case 'target_products':
    return t('title.brandProductsScraper', { brand: 'Target' });
  case 'thuisbezorgd_reviews':
    return t('title.brandReviewsScraper', { brand: 'Thuisbezorgd' });
  case 'tiktok_comments':
    return t('title.brandCommentsScraper', { brand: 'TikTok' });
  case 'tiktok_hashtags':
    return t('title.brandHashtagsScraper', { brand: 'TikTok' });
  case 'tiktok_products':
    return t('title.brandProductsScraper', { brand: 'TikTok' });
  case 'tiktok_search':
    return t('title.brandSearchScraper', { brand: 'TikTok' });
  case 'tiktok_videos':
    return t('title.brandVideosScraper', { brand: 'TikTok' });
  case 'tripadvisor_reviews_monitoring':
    return t('title.brandReviewsMonitoring', { brand: 'Tripadvisor' });
  case 'trustpilot_reviews_monitoring':
    return t('title.brandReviewsMonitoring', { brand: 'Trustpilot' });
  case 'uber_eats':
    return t('title.brandScraper', { brand: 'Uber Eats' });
  case 'uline_products':
    return t('title.brandProductsScraper', { brand: 'Uline' });
  case 'upwork_jobs':
    return t('title.brandJobs', { brand: 'Upwork' });
  case 'vistaprint_products':
    return t('title.brandProductsScraper', { brand: 'Vistaprint' });
  case 'vrbo_search':
    return t('title.brandSearchScraper', { brand: 'Vrbo' });
  case 'waxie_products':
    return t('title.brandProductsScraper', { brand: 'Waxie' });
  case 'wbmason_products':
    return t('title.brandProductsScraper', { brand: 'Wbmason' });
  case 'willhaben':
    return t('title.brandScraper', { brand: 'Willhaben' });
  case 'yahoo_search':
    return t('title.brandSearchScraper', { brand: 'Yahoo' });
  case 'yelp_photos':
    return t('title.Y.E.L.P Photos Scraper');
  case 'yelp_reviews_service':
    return t('title.Y.E.L.P Reviews Scraper');
  case 'yelp_service':
    return t('title.Y.E.L.P Businesses Scraper');
  case 'youtube_transcripts':
    return t('title.brandTranscriptsScraper', { brand: 'YouTube' });
  case 'youtube_videos':
    return t('title.brandVideoScraper', { brand: 'YouTube' });
  case 'zalando_products':
    return t('title.brandProductsScraper', { brand: 'Zalando' });
  case 'zillow_agents':
    return t('title.brandAgentsScraper', { brand: 'Zillow' });
  case 'zillow_reviews':
    return t('title.brandReviewsScraper', { brand: 'Zillow' });
  case 'zillow_transactions':
    return t('title.brandTransactionsScraper', { brand: 'Zillow' });
  case 'zoro_products':
    return t('title.brandProductsScraper', { brand: 'Zoro' });
  case 'ai_chain_info':
    return t('title.Chain Info');
  case 'ai_scraper':
    return t('title.AI Scraper');
  case 'ai_scraper_service':
    return t('title.Universal AI-Powered Scraper');
  case 'airbnb_reviews':
    return t('title.Airbnb Reviews Scraper');
  case 'airbnb_search':
    return t('title.Airbnb Search Scraper');
  case 'amazon_products_service':
    return t('title.Amazon Products Scraper');
  case 'amazon_reviews_service':
    return t('title.Amazon Reviews Scraper');
  case 'appstore_reviews_service':
    return t('title.AppStore Reviews Scraper');
  case 'appstore_search_service':
    return t('title.AppStore Search Scraper');
  case 'bestbuy_products':
    return t('title.BestBuy Products Scraper');
  case 'bestbuy_reviews':
    return t('title.BestBuy Reviews Scraper');
  case 'bestbuy_reviews_sentiment':
    return t('title.BestBuy Reviews Sentiment Analysis');
  case 'bestbuy_reviews_summary':
    return t('title.BestBuy Reviews Summary');
  case 'biggestbook_products':
    return t('title.BiggestBook Products Scraper');
  case 'booking_prices_service':
    return t('title.Booking Prices Scraper');
  case 'booking_reviews_service':
    return t('title.Booking Reviews Scraper');
  case 'booking_search_service':
    return t('title.Booking Search Scraper');
  case 'boots_products':
    return t('title.Boots Products Scraper');
  case 'business_directory_service':
    return t('title.Business Directory');
  case 'capterra_reviews':
    return t('title.Capterra Reviews Scraper');
  case 'companies_data':
    return t('title.US Companies Data Enricher');
  case 'company_insights_service':
    return t('title.Company Insights');
  case 'company_websites_finder':
    return t('title.companyWebsiteFinder');
  case 'contacts_finder_service':
    return t('title.Contacts Finder');
  case 'costco_products':
    return t('title.Costco Products Scraper');
  case 'customink_products':
    return t('title.Customink Products Scraper');
  case 'domains_service':
    return t('title.Emails & Contacts Scraper');
  case 'disposable_email_checker':
    return t('title.Disposable Email Checker');
  case 'doordash_search':
    return t('title.Doordash Scraper');
  case 'ebay_products':
    return t('title.eBay Products Scraper');
  case 'email_finder_service':
    return t('title.Email Addresses Finder');
  case 'emails_validator_service':
    return t('title.Email Address Verifier');
  case 'etsy_products':
    return t('title.Etsy Products Scraper');
  case 'etsy_reviews':
    return t('title.Etsy Reviews Scraper');
  case 'expedia_reviews':
    return t('title.Expedia Reviews Scraper');
  case 'expedia_search':
    return t('title.Expedia Search Scraper');
  case 'fastbackgroundcheck_addresses':
    return t('title.Fastbackgroundcheck Addresses Scraper');
  case 'fastenal_products':
    return t('title.Fastenal Products Scraper');
  case 'g2_reviews':
    return t('title.G2 Reviews Scraper');
  case 'geocoding':
    return t('title.Geocoding');
  case 'getapp_reviews':
    return t('title.GetApp Reviews Scraper');
  case 'glassdoor_reviews_service':
    return t('title.Glassdoor Reviews Scraper');
  case 'glassdoor_search':
    return t('title.Glassdoor Job Scraper');
  case 'google_careers_service':
    return t('title.Google Search Careers');
  case 'google_maps_contributor_reviews_service':
    return t('title.Google Maps Contributor Reviews Scraper');
  case 'google_maps_directory_service':
    return t('title.Google Maps Directory Places');
  case 'google_maps_photos_service':
    return t('title.Google Maps Photos Scraper');
  case 'google_maps_reviews_service':
    return t('title.Google Maps Reviews Scraper');
  case 'google_maps_service':
    return t('title.Google Maps Data Scraper');
  case 'google_maps_autocomplete':
    return t('title.googleMapsAutocomplete');
  case 'google_maps_traffic_service':
    return t('title.Google Maps Traffic Scraper');
  case 'google_places_domain_search_service':
    return t('title.Google Maps Search by Domains');
  case 'google_play_reviews_service':
    return t('title.Google Play Reviews Scraper');
  case 'google_search_events_service':
    return t('title.Google Search Events Scraper');
  case 'google_search_images_service':
    return t('title.Google Search Images Scraper');
  case 'google_search_jobs_service':
    return t('title.Google Search Jobs');
  case 'google_search_news_service':
    return t('title.Google Search News Scraper');
  case 'google_search_service':
    return t('title.Google Search Scraper');
  case 'google_search_flights':
    return t('title.googleSearchFlightsScraper');
  case 'google_search_shopping_service':
    return t('title.Google Search Shopping Scraper');
  case 'google_search_videos_service':
    return t('title.Google Search Videos Scraper');
  case 'google_shopping_reviews_service':
    return t('title.Google Shopping Reviews Scraper');
  case 'google_trends':
    return t('title.Google Trends Scraper');
  case 'homedepot_reviews':
    return t('title.Home Depot Reviews Scraper');
  case 'hotels_reviews':
    return t('title.Hotels Reviews Scraper');
  case 'hotels_search':
    return t('title.Hotels Search Scraper');
  case 'hubspot_contact_emails_enricher_service':
    return t('title.HubSpot Contact Emails Finder');
  case 'hubspot_contact_finder_service':
    return t('title.HubSpot Company Contacts Finder');
  case 'indeed_reviews':
    return t('title.Indeed Reviews Scraper');
  case 'indeed_search':
    return t('title.Indeed Job Scraper');
  case 'iteminfo_products':
    return t('title.ItemInfo Products Scraper');
  case 'leads_n_contacts':
    return t('title.contactLeads');
  case 'linkedin_companies_service':
    return t('title.Linkedin Companies Scraper');
  case 'linkedin_posts':
    return t('title.Linkedin Posts Scraper');
  case 'linkedin_profiles':
    return t('title.Linkedin Profiles Scraper');
  case 'lowes_products':
    return t('title.Lowes Products Scraper');
  case 'lyreco_products':
    return t('title.Lyreco Products Scraper');
  case 'macys_products':
    return t('title.Macys Products Scraper');
  case 'mobilede':
    return t('title.Mobilede Scraper');
  case 'offerup':
    return t('title.Offerup Scraper');
  case 'officedepot_products':
    return t('title.Office Depot Products Scraper');
  case 'phones_enricher_service':
    return t('title.Phone Numbers Enricher');
  case 'places_search_service':
    return t('title.Places Search Service');
  case 'people_search':
    return t('title.People Search');
  case 'producthunt_reviews':
    return t('title.Product Hunt Reviews Scraper');
  case 'quill_products':
    return t('title.Quill Products Scraper');
  case 'reddit_comments':
    return t('title.Reddit Comments Scraper');
  case 'reddit_search':
    return t('title.Reddit Search Scraper');
  case 'reverse_geocoding':
    return t('title.Reverse Geocoding');
  case 'samsclub_products':
    return t('title.Sams Club Products Scraper');
  case 'screenshoter':
    return t('title.WebPage Screenshoter');
  case 'shopee_reviews':
    return t('title.Shopee Reviews Scraper');
  case 'shopify_products':
    return t('title.Shopify Products Scraper');
  case 'similarweb':
    return t('title.SimilarWeb Scraper');
  case 'staples_products':
    return t('title.Staples Products Scraper');
  case 'target_reviews':
    return t('title.Target Reviews Scraper');
  case 'tesco_products':
    return t('title.Tesco Products Scraper');
  case 'tiktok_profiles':
    return t('title.TikTok Profiles Scraper');
  case 'tripadvisor_reviews_service':
    return t('title.Tripadvisor Reviews Scraper');
  case 'tripadvisor_search':
    return t('title.Tripadvisor Search Scraper');
  case 'trustpilot_reviews_service':
    return t('title.Trustpilot Reviews Scraper');
  case 'trustpilot_search_service':
    return t('title.Trustpilot Search Scraper');
  case 'trustpilot_service':
    return t('title.Trustpilot Scraper');
  case 'twitter_profiles':
    return t('title.Twitter Profiles Scraper');
  case 'walmart_products':
    return t('title.Walmart Products Scraper');
  case 'walmart_reviews':
    return t('title.Walmart Reviews Scraper');
  case 'webstaurantstore_products':
    return t('title.Webstaurantstore Products Scraper');
  case 'whatsapp_checker_service':
    return t('title.WhatsApp Checker');
  case 'whitepages_addresses':
    return t('title.Whitepages Addresses Scraper');
  case 'whitepages_phones':
    return t('title.Phone Identity Finder');
  case 'yellowpages_service':
    return t('title.Yellow Pages Search Scraper');
  case 'youtube_channel_service':
    return t('title.YouTube Channels Scraper');
  case 'youtube_comments_service':
    return t('title.YouTube Comments Scraper');
  case 'youtube_comments_sentiment':
    return t('title.brandCommentsSentimentAnalysis', { brand: 'YouTube' });
  case 'youtube_comments_summary':
    return t('title.brandCommentsSummary', { brand: 'YouTube' });
  case 'youtube_search_service':
    return t('title.YouTube Search Scraper');
  case 'zillow_search_service':
    return t('title.Zillow Search Scraper');
  case 'zoominfo':
    return t('title.Zoominfo Scraper');
  case 'zoominfo_domains':
    return t('title.Zoominfo by Domains');
  default: {
    const brand = getReviewAnalysisBrand(logicalServiceId);
    if (brand) {
      return logicalServiceId.endsWith('_sentiment')
        ? t('title.brandReviewsSentimentAnalysis', { brand })
        : t('title.brandReviewsSummary', { brand });
    }
    return fallbackTitle;
  }
  }
};

export const localizeServiceDescription = (t, serviceId, fallbackDescription = '') => {
  const logicalServiceId = serviceId?.replace(/_v\d+$/, '');

  switch (logicalServiceId) {
  case 'asos_products':
  case 'autozone_products':
  case 'bestbuy_products':
  case 'biggestbook_products':
  case 'boots_products':
  case 'bradyindustries_products':
  case 'cdw_products':
  case 'costco_products':
  case 'customink_products':
  case 'decathlon_products':
  case 'etsy_products':
  case 'fastenal_products':
  case 'ferguson_products':
  case 'gemplers_products':
  case 'globalindustrial_products':
  case 'grainger_products':
  case 'groupon_products':
  case 'homedepot_products':
  case 'iteminfo_products':
  case 'lowes_products':
  case 'lyreco_products':
  case 'macys_products':
  case 'menards_products':
  case 'napaonline_products':
  case 'newegg_products':
  case 'northerntool_products':
  case 'officedepot_products':
  case 'otto_products':
  case 'quill_products':
  case 'samsclub_products':
  case 'staples_products':
  case 'target_products':
  case 'tesco_products':
  case 'tiktok_products':
  case 'uline_products':
  case 'vistaprint_products':
  case 'walmart_products':
  case 'waxie_products':
  case 'wbmason_products':
  case 'webstaurantstore_products':
  case 'zalando_products':
  case 'zoro_products':
    return fallbackDescription ? t('description.ebay_products') : fallbackDescription;
  case 'better_business_bureau':
    return t('description.better_business_bureau');
  case 'appstore_search_service':
  case 'bing_places':
  case 'ipinfo':
  case 'reddit_search':
  case 'shopify_apps':
  case 'vrbo_search':
  case 'yahoo_search':
  case 'youtube_search_service':
    return fallbackDescription ? t('description.google_search_service') : fallbackDescription;
  case 'producthunt_profiles':
  case 'youtube_channel_service':
    return t('description.linkedin_profiles');
  case 'better_business_bureau_reviews':
    return t('description.yelp_reviews_service');
  case 'reddit_comments':
    return t('description.youtube_comments_service');
  case 'baidu_maps':
    return t('description.yelp_service');
  case 'ai_scraper':
    return t('description.ai_scraper_service');
  case 'similarweb':
    return t('description.similarweb');
  case 'builtwith':
    return t('description.builtwith');
  case 'domaininfo':
    return t('description.domaininfo');
  case 'google_search_autocomplete':
    return t('description.google_search_autocomplete');
  case 'eventbrite':
    return t('description.brandEventListings', { brand: 'Eventbrite' });
  case 'meetup':
    return t('description.brandEventListings', { brand: 'Meetup.com' });
  case 'glassdoor_company_search':
    return t('description.brandCompanySearch', { brand: 'Glassdoor' });
  case 'tiktok_hashtags':
    return t('description.brandHashtagData', { brand: 'TikTok' });
  case 'tiktok_search':
    return t('description.brandSearchResults', { brand: 'TikTok' });
  case 'tiktok_videos':
    return t('description.brandVideoData', { brand: 'TikTok' });
  case 'tiktok_comments':
    return t('description.brandVideoComments', { brand: 'TikTok' });
  case 'bestbuy_reviews':
    return t('description.brandProductReviews', { brand: 'Best Buy' });
  case 'etsy_reviews':
    return t('description.brandProductReviews', { brand: 'Etsy' });
  case 'doordash_search':
    return t('description.brandRestaurantData', { brand: 'DoorDash' });
  case 'zillow_reviews':
    return t('description.brandAgentReviews', { brand: 'Zillow' });
  case 'zillow_agents':
    return t('description.brandAgentData', { brand: 'Zillow' });
  case 'zillow_transactions':
    return t('description.brandAgentTransactions', { brand: 'Zillow' });
  case 'streeteasy':
    return t('description.brandPropertyListings', { brand: 'StreetEasy.com' });
  case 'youtube_transcripts':
    return t('description.brandVideoTranscripts', { brand: 'YouTube' });
  case 'hubspot_contact_emails_enricher_service':
    return t('description.hubspotContactEmails');
  case 'hubspot_contact_finder_service':
    return t('description.hubspotCompanyContacts');

  case 'ai_chain_info':
    return t('description.ai_chain_info');
  case 'ai_scraper_service':
    return t('description.ai_scraper_service');
  case 'airbnb_reviews':
    return t('description.airbnb_reviews');
  case 'airbnb_search':
    return t('description.airbnb_search');
  case 'amazon_products_service':
    return t('description.amazon_products_service');
  case 'amazon_reviews_service':
    return t('description.amazon_reviews_service');
  case 'appstore_reviews_service':
    return t('description.appstore_reviews_service');
  case 'booking_prices_service':
    return t('description.booking_prices_service');
  case 'booking_reviews_service':
    return t('description.booking_reviews_service');
  case 'booking_search_service':
    return t('description.booking_search_service');
  case 'capterra_reviews':
    return t('description.capterra_reviews');
  case 'companies_data':
    return t('description.companies_data');
  case 'company_insights_service':
    return t('description.company_insights_service');
  case 'company_websites_finder':
    return t('description.company_websites_finder');
  case 'domains_service':
    return t('description.domains_service');
  case 'disposable_email_checker':
    return t('description.disposable_email_checker');
  case 'ebay_products':
    return t('description.ebay_products');
  case 'email_finder_service':
    return t('description.email_finder_service');
  case 'emails_validator_service':
    return t('description.emails_validator_service');
  case 'expedia_reviews':
    return t('description.expedia_reviews');
  case 'expedia_search':
    return t('description.expedia_search');
  case 'fastbackgroundcheck_addresses':
    return t('description.fastbackgroundcheck_addresses');
  case 'g2_reviews':
    return t('description.g2_reviews');
  case 'geocoding':
    return t('description.geocoding');
  case 'getapp_reviews':
    return t('description.getapp_reviews');
  case 'glassdoor_reviews_service':
    return t('description.glassdoor_reviews_service');
  case 'glassdoor_search':
    return t('description.glassdoor_search');
  case 'google_careers_service':
    return t('description.google_careers_service');
  case 'google_maps_contributor_reviews_service':
    return t('description.google_maps_contributor_reviews_service');
  case 'google_maps_photos_service':
    return t('description.google_maps_photos_service');
  case 'google_maps_reviews_service':
    return t('description.google_maps_reviews_service');
  case 'google_maps_service':
    return t('description.google_maps_service');
  case 'google_maps_autocomplete':
    return t('description.google_maps_autocomplete');
  case 'google_maps_traffic_service':
    return t('description.google_maps_traffic_service');
  case 'google_places_domain_search_service':
    return t('description.google_places_domain_search_service');
  case 'places_search_service':
    return t('description.places_search_service');
  case 'google_play_reviews_service':
    return t('description.google_play_reviews_service');
  case 'google_search_events_service':
    return t('description.google_search_events_service');
  case 'google_search_images_service':
    return t('description.google_search_images_service');
  case 'google_search_jobs_service':
    return t('description.google_search_jobs_service');
  case 'google_search_news_service':
    return t('description.google_search_news_service');
  case 'google_search_service':
    return t('description.google_search_service');
  case 'google_search_flights':
    return t('description.google_search_flights');
  case 'google_search_shopping_service':
    return t('description.google_search_shopping_service');
  case 'google_search_videos_service':
    return t('description.google_search_videos_service');
  case 'google_shopping_reviews_service':
    return t('description.google_shopping_reviews_service');
  case 'google_trends':
    return t('description.google_trends');
  case 'homedepot_reviews':
    return t('description.homedepot_reviews');
  case 'hotels_reviews':
    return t('description.hotels_reviews');
  case 'hotels_search':
    return t('description.hotels_search');
  case 'indeed_reviews':
    return t('description.indeed_reviews');
  case 'indeed_search':
    return t('description.indeed_search');
  case 'leads_n_contacts':
    return t('description.leads_n_contacts');
  case 'linkedin_companies_service':
    return t('description.linkedin_companies_service');
  case 'linkedin_posts':
    return t('description.linkedin_posts');
  case 'linkedin_profiles':
    return t('description.linkedin_profiles');
  case 'phones_enricher_service':
    return t('description.phones_enricher_service');
  case 'people_search':
    return t('description.people_search');
  case 'producthunt_reviews':
    return t('description.producthunt_reviews');
  case 'reverse_geocoding':
    return t('description.reverse_geocoding');
  case 'screenshoter':
    return t('description.screenshoter');
  case 'shopee_reviews':
    return t('description.shopee_reviews');
  case 'shopify_products':
    return t('description.shopify_products');
  case 'target_reviews':
    return t('description.target_reviews');
  case 'tiktok_profiles':
    return t('description.tiktok_profiles');
  case 'tripadvisor_reviews_service':
    return t('description.tripadvisor_reviews_service');
  case 'tripadvisor_search':
    return t('description.tripadvisor_search');
  case 'trustpilot_reviews_service':
    return t('description.trustpilot_reviews_service');
  case 'trustpilot_search_service':
    return t('description.trustpilot_search_service');
  case 'trustpilot_service':
    return t('description.trustpilot_service');
  case 'twitter_profiles':
    return t('description.twitter_profiles');
  case 'walmart_reviews':
    return t('description.walmart_reviews');
  case 'whitepages_addresses':
    return t('description.whitepages_addresses');
  case 'whitepages_phones':
    return t('description.whitepages_phones');
  case 'yellowpages_service':
    return t('description.yellowpages_service');
  case 'yelp_photos':
    return t('description.yelp_photos');
  case 'yelp_reviews_service':
    return t('description.yelp_reviews_service');
  case 'yelp_service':
    return t('description.yelp_service');
  case 'youtube_comments_service':
    return t('description.youtube_comments_service');
  case 'zillow_search_service':
    return t('description.zillow_search_service');
  default:
    if (getReviewAnalysisBrand(logicalServiceId)
      || logicalServiceId === 'youtube_comments_sentiment'
      || logicalServiceId === 'youtube_comments_summary') {
      return logicalServiceId.endsWith('_sentiment')
        ? t('description.reviewsSentiment')
        : t('description.reviewsSummary');
    }
    return fallbackDescription;
  }
};

export const localizeExportTitle = (t, unitName, fallbackTitle = '') => {
  switch (unitName) {
  case 'SMS':
    return t('title.exportSMS');
  case 'email':
    return t('title.exportemail');
  case 'message':
    return t('title.exportmessage');
  case 'review':
    return t('title.exportreview');
  default:
    return fallbackTitle;
  }
};

export const localizeStartTaskButtonTranslationKey = (t, translationKey, fallbackTitle = '') => {
  switch (translationKey) {
  case 'action.findContacts':
    return t('action.findContacts');
  case 'action.findLeadsAndContacts':
    return t('action.findLeadsAndContacts');
  case 'action.downloadPhotos':
    return t('action.downloadPhotos');
  case 'action.exportAgents':
    return t('action.exportAgents');
  case 'action.exportTransactions':
    return t('action.exportTransactions');
  case 'action.enrichContacts':
    return t('action.enrichContacts');
  case 'action.validateEmails':
    return t('action.validateEmails');
  case 'action.send':
    return t('action.send');
  case 'action.startMonitoring':
    return t('action.startMonitoring');
  case 'action.summarizeReviews':
    return t('action.summarizeReviews');
  case 'action.analyzeSentiment':
    return t('action.analyzeSentiment');
  case 'title.Analyze Sentiment':
    return t('action.analyzeSentiment');
  case 'title.Enrich Contacts':
    return t('action.enrichContacts');
  case 'title.Send':
    return t('action.send');
  case 'title.Start Monitoring':
    return t('action.startMonitoring');
  case 'title.Summarize Reviews':
    return t('action.summarizeReviews');
  case 'title.exportemail':
    return t('action.validateEmails');
  default:
    return fallbackTitle;
  }
};

export const localizeStartTaskButtonTitle = (t, serviceId, unitName, fallbackTitle = '') => {
  switch (serviceId) {
  case 'leads_n_contacts':
    return t('action.findLeadsAndContacts');
  case 'google_maps_photos_service':
    return t('action.downloadPhotos');
  case 'zillow_agents':
    return t('action.exportAgents');
  case 'zillow_transactions':
    return t('action.exportTransactions');
  case 'hubspot_contact_emails_enricher_service':
    return t('action.enrichContacts');
  case 'emails_validator_service':
    return t('action.validateEmails');
  case 'messaging_service':
  case 'whatsapp_sender':
    return t('action.send');
  default:
    if (serviceId.endsWith('_summary')) {
      return t('action.summarizeReviews');
    }

    if (serviceId.endsWith('_sentiment')) {
      return t('action.analyzeSentiment');
    }

    if (serviceId.endsWith('_monitoring')) {
      return t('action.startMonitoring');
    }

    return localizeExportTitle(t, unitName, fallbackTitle);
  }
};
